<template>
  <div class="relative min-h-screen w-full flex justify-center items-center py-16 md:py-10">
    <div class="card md:w-lg w-screen z-10">
      <div class="text-center px-10 py-12">
        <Link href="/" class="flex justify-center">
          <img :src="branding.logoUrl || logodark" :alt="`${branding.appName} logo`" class="h-20 w-auto flex dark:hidden" />
          <img :src="branding.logoDarkUrl || logolight" :alt="`${branding.appName} logo`" class="h-20 w-auto hidden dark:flex" />
        </Link>
        <slot />
      </div>
    </div>
    <div class="absolute inset-0 overflow-hidden">
      <svg aria-hidden="true" class="absolute inset-0 size-full fill-black/2 stroke-black/5 dark:fill-white/2.5 dark:stroke-white/2.5">
        <defs>
          <pattern id="authPattern" width="56" height="56" patternUnits="userSpaceOnUse" x="50%" y="16">
            <path d="M.5 56V.5H72" fill="none"></path>
          </pattern>
        </defs>
        <rect width="100%" height="100%" stroke-width="0" fill="url(#authPattern)"></rect>
      </svg>
    </div>
  </div>
</template>

<script setup>
import { Link } from '@inertiajs/vue3'
import logolight from '@/assets/images/logo-dark.png'
import logodark from '@/assets/images/logo-light.png'
import { useBranding } from '@/composables/useBranding'

// Bundled imports stay as the fallback for an instance that has uploaded nothing.
const branding = useBranding()
</script>
